<div>
  <input
    #frequencyInput="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="ag-text-field-input"
    type="text"
    [(ngModel)]="currentValue"
    (click)="openMenu()"
    [ngClass]="currentValue ? 'input-background-active' : ''" />
    @if (!currentValue) {
      <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
    }
    @if (currentValue) {
      <span class="sdps-text-secondary delete-icon-padding" (click)="clearFrequency($event)"
        ><img class="deleteIcon" [src]="deleteIcon"
      /></span>
    }
    <ng-template
      cdkConnectedOverlay
      (overlayOutsideClick)="toggleFrequency(false)"
      (overlayKeydown)="toggleFrequency(false)"
      [cdkConnectedOverlayOrigin]="frequencyInput"
      [cdkConnectedOverlayOpen]="isOpen">
      <div class="container">
        <div class="radio-btns">
          <ul>
            @for (frequencyType of frequencyOptions; track frequencyType) {
              <div class="frequency-item">
                <input type="radio" [id]="frequencyType" name="frequency" [(ngModel)]="selectedValue" [value]="frequencyType" />
                <label [for]="frequencyType" [innerText]="frequencyType"></label>
              </div>
            }
          </ul>
        </div>
        <div class="filter-actions">
          <button type="button" class="btn btn-success" (click)="applyFrequency()">Apply</button>
          <a href="#" (click)="clearFrequency($event)"> Clear </a>
        </div>
      </div>
    </ng-template>
  </div>
